import { ZodiacAquariusIcon } from './ZodiacAquariusIcon';

/**
 * author: Michael Richins
 * id 8E27593E-7C4E-41F7-A238-865DA00CDEE7
 * name zodiac-aquarius
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/zodiac-aquarius.svg
 * tags
 */
export const HoroscopeAquariusIcon = ZodiacAquariusIcon;
export default HoroscopeAquariusIcon